module.exports = __webpack_public_path__ + "img/1.f4201377.jpg";